export enum DateTimeFormats {
    Date = 1,
    Time,
    ShortTime,
    DateTime,
    DateShortTime
}
